export default "__VITE_ASSET__PcS5nEFU__"